// src/sections/HeroSection.jsx
import React from 'react';

const HeroSection = () => (
  <section id="hero" className="hero-content" data-scroll-section>
    <div data-scroll data-scroll-speed="2">
      <h1>Visuals that speak for themselves</h1>
      <p>Every shoot, every shot, everytake is built around <strong>your</strong> story...</p>
      <p>More than pictures, more than a show reel, more than a corporate message — they’re an investment...</p>
      <p>This is about your future — and the version of you they’ll remember.</p>
    </div>
  </section>
);

export default HeroSection;